import { Component, OnInit,ElementRef,ViewChild } from '@angular/core';
import { MasterService,FeecounterService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-generatefees',
  templateUrl: './generatefees.component.html',
  styleUrls: ['./generatefees.component.scss'],
  providers:[MasterService,FeecounterService]
})
export class GeneratefeesComponent implements OnInit {

  constructor(private http: HttpClient,private aservice:FeecounterService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }
  sections:any=[];
  classes:any=[];
  arrstudent:any=[];
  fmodel:any={clid:'0',secid:'0',subid:'0',prid:'0'};
  fmodel1:any={clid:'0',secid:'0',accatid:'0',prid:'0'};
  
  arrrepdata:any=[];
  arrper:any=[];
  arrrechead:any=[];
  arrastype:any=[];
  arracchead:any=[];
  recdetails:any=[];
  arrcol:any=[];
  accat:any=[];
  arrfeerech:any=[];
  objvhead:any={};
  objfcol:any={};
  oprtype:any='';
  oprtype1:any='';
  tabledata: any = {};
  ttldfeamt=0;
  arrfeesum:any=[];
  showload='No';
  sertxt:any="";
  catid:any;
  arrcourse:any=[];
  arfeequota1:any=[];
  arfeequota:any=[];
  arfeequotatp:any=[];
  arfeequotahs:any=[];
  arpayopt:any=[];
  modalOptions:NgbModalOptions;

  modalOptions1:NgbModalOptions;
  private modalRef: NgbModalRef;
  private modalRef1: NgbModalRef;



  ngOnInit(): void {
    
    
    //this.masmot();
    this.getcourses();
    this.masacccat();
    this.masfeequota();
    this.maspayopts();

  }

 

  
  private getcourses() {

    this.mservice.getcourse()
  .subscribe((result:any) => {
  
  this.arrcourse=result;
  this.fmodel.crid=result[0].crid;
  this.masclass();
  
  }, error => {
  
  //alert('error in r');
  // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
  }
  );
    
    
  }

  updatepayopt(obj)
  {

    if(confirm("Are you sure you wan't to modify details."))
    this.aservice.updatefeeoptions(obj)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            alert(resultArray.message);
           this.getrecdetails();
        },
        error => console.log("Error :: " + error)
        )
  }
  

  masacccat() {
    debugger
    this.mservice.masacccat()
        .subscribe(
        resultArray => {
            console.log('getacccategory', resultArray);
            this.accat = resultArray;
            this.fmodel.accatid=resultArray[0].accatid;
           // this.catid=resultArray[0].accatid;
            //this.getrecdetails('selhtop20','',resultArray[0].accatid);
           
        },
        error => console.log("Error :: " + error)
        )
  }


  

  masclass() {
    this.mservice.masclass()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
           this.fmodel.clid=resultArray[0].clid;
            this.massection();
            
            
           
        },
        error => console.log("Error :: " + error)
        )
  }


  massection() {
    this.mservice.massection()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.sections = resultArray;
            this.fmodel.scid=resultArray[0].scid;
            //this.by_sp_student();
           this.getrecdetails();
        },
        error => console.log("Error :: " + error)
        )
  }


  getrecdetails()
{
  debugger
 
console.log('fmodel',this.fmodel);
   this.aservice.getvochersbyclass(this.fmodel)
  
  //this.acservice.Acreceiptheader('1','1',this.tempdbnm)
  .subscribe(
    
   resultArray =>{
    console.log('result',resultArray) ;
    
    this.recdetails = resultArray;

   
    },
   error => {console.log("Error :: " + error);
  
  alert('error while fetching results');}
)

}

masfeequota() {
  this.mservice.masfeequota()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.arfeequota1 = resultArray;
          this.arfeequota = resultArray.filter(item=>item.accatid==1);
          this.arfeequotatp = resultArray.filter(item=>item.accatid==2);
          this.arfeequotahs = resultArray.filter(item=>item.accatid==5);
         
      },
      error => console.log("Error :: " + error)
      )
}
maspayopts() {
  this.mservice.maspayopt()
      .subscribe(
      resultArray => {
          console.log('maspayopt', resultArray);
          this.arpayopt = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}

generate_student(obj,oprtype) {
  if(confirm("Are you sure you wan't to "+oprtype+" voucher"))
  this.aservice.generatevocher(obj,oprtype)
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          alert(resultArray.message);
         this.getrecdetails();
      },
      error => console.log("Error :: " + error)
      )
}
}
